import {registerBlockType} from "@wordpress/blocks"
import 'animate.css';
const { RichText,  ColorPalette,  InspectorControls,  BlockControls,  AlignmentToolbar,  withColors,  FontSizePicker, getColorClassName, PanelColorSettings} = wp.blockEditor;
import { PanelBody, Button, ResponsiveWrapper, RangeControl, ToggleControl, SelectControl, TextControl, __experimentalBoxControl as BoxControl, BaseControl, __experimentalInputControl as InputControl, TextareaControl} from '@wordpress/components';
const { Fragment } = wp.element;
const { __ } = wp.i18n;
import {fontfamilylist} from "./lib/fontfamilylist.js";

const BlockEdit = (props) => {
	
	const { attributes, setAttributes } = props;
	const{ title, Contenttag, titleColor, bgColor, shadowColor, margins, paddings, fontfamily, titlefontSize, TitleLineHeight, TitleFontWeight, TitleTransform, TitleDecoration, TitleLetterSpacing, hshadow, vshadow, blurshadow, hidedesktop, hidetablet, hidemobile, animation, durations, delay, addclass, customcss }=attributes;	
	const blockclass='spice-blocks-heading';
	const alignmentClass = (attributes.textAlignment != null) ? 'has-text-align-' + attributes.textAlignment : '';
	const animationclass='wow animated '+attributes.durations+' '+attributes.animation;
	const displaydesktop=(hidedesktop == false) ? 'hide-desktop' : '';
	const displaytablet=(hidetablet == false) ? 'hide-tablet' : '';
	const displaymobile=(hidemobile == false) ? 'hide-mobile' : '';
	const displayclass=displaydesktop+' '+displaytablet+' '+displaymobile;

	function setTitle(value) {
		setAttributes({title:value});
	}
	function setTitleColor(value) {
		setAttributes({titleColor:value});
	}
	function setBgColor(value) {
		setAttributes({bgColor:value});
	}
	function setShadowColor(value) {
		setAttributes({shadowColor:value});
	}
	function setPaddings(value){
		setAttributes({
			paddings: {
						top: value,
						left: value,
						right: value,
						bottom: value
					}
				})
		
	}	
	if(fontfamily !=null){
		let url = 'https://fonts.googleapis.com/css2?family='+fontfamily+':wght@100;200;300;400;500;600;700;800;900&display=swap';
         let link = document.createElement('link')
          link.href = url;
          link.rel = "stylesheet";
          link.type =  "text/css";
          
          if ( jQuery("body").hasClass("site-editor-php") ) { 
          jQuery('iframe').contents().find("head").append(link);
      }
      else{
      	document.head.appendChild(link);
      }
    }  	
	    
	return(
		<Fragment>
			<style dangerouslySetInnerHTML={{
		  		__html: [
			     `${customcss}`					
			    ].join('\n')
			  }}>
			</style>
			<InspectorControls>

				<PanelBody initialOpen={false} title={__('General Settings','spice-blocks')}>
					<SelectControl
			            label={__('Content','spice-blocks')}
			            value={ Contenttag }
			            options={ [
			                { label: __('H1','spice-blocks'), value: 'h1' },
			                { label: __('H2','spice-blocks'), value: 'h2' },
			                { label: __('H3','spice-blocks'), value: 'h3' },
			                { label: __('H4','spice-blocks'), value: 'h4' },
			                { label: __('H5','spice-blocks'), value: 'h5' },
			                { label: __('H6','spice-blocks'), value: 'h6' },
			            ] }
			            onChange={ (newtext) => setAttributes({ Contenttag: newtext }) }					  
			        />
					<BoxControl 
						label={__('Margin','spice-blocks')}
						inputProps={{ min: -300 }}
						values={margins}
						sides={['top', 'bottom','left','right']}
						allowReset={false}
						units={[]}
						onChange={(newValue) =>
							setAttributes({
								...margins,
								margins: {
									top: newValue.top,
									left: newValue.left,
									right: newValue.right,
									bottom: newValue.bottom,
								},
							})
						}
					/>
          			<BoxControl
						values={paddings}
						label={__('Content Padding','spice-blocks')}
						units={[]}
						allowReset={false}
						onChange={(newValue) =>
							setAttributes({
								...paddings,
								paddings: {
									top: newValue.top,
									left: newValue.left,
									right: newValue.right,
									bottom: newValue.bottom,
								},
							})
						}
					/>	

					<PanelBody initialOpen={false} title={__('Display','spice-blocks')} className={'spice-panel-edit'}>					
						<ToggleControl
							label={__('Enable/Disable on Desktop','spice-blocks')}
							checked={hidedesktop}
							onChange={(newval) => setAttributes({ hidedesktop: newval })}
						/>
						<ToggleControl
							label={__('Enable/Disable on Tablet','spice-blocks')}
							checked={hidetablet}
							onChange={(newval) => setAttributes({ hidetablet: newval })}
						/>
						<ToggleControl
							label={__('Enable/Disable on Mobile','spice-blocks')}
							checked={hidemobile}
							onChange={(newval) => setAttributes({ hidemobile: newval })}
						/>
					</PanelBody>

					<PanelBody initialOpen={false} title={__('Animation Effects','spice-blocks')} className={'spice-panel-edit'}>
		        		<SelectControl
				            label={__('Animation','spice-blocks')}
				            value={ animation }
				            options={ [
				            	{ label: __('None','spice-blocks'), value: ' ' },
                                { label: __('Bounce','spice-blocks'), value: 'bounce' },
                                { label: __('Flash','spice-blocks'), value: 'flash' },
                                { label: __('Pulse','spice-blocks'), value: 'pulse' },
                                { label: __('RubberBand','spice-blocks'), value: 'rubberBand' },
                                { label: __('Shake','spice-blocks'), value: 'shake' },
                                { label: __('Swing','spice-blocks'), value: 'swing' },
                                { label: __('Tada','spice-blocks'), value: 'tada' },
                                { label: __('Wobble','spice-blocks'), value: 'wobble' },
                                { label: __('Jello','spice-blocks'), value: 'jello' },
                                { label: __('BounceIn','spice-blocks'), value: 'bounceIn' },
                                { label: __('BounceInDown','spice-blocks'), value: 'bounceInDown' },
                                { label: __('BounceInLeft','spice-blocks'), value: 'bounceInLeft' },
                                { label: __('BounceInRight','spice-blocks'), value: 'bounceInRight' },
                                { label: __('BounceInUp','spice-blocks'), value: 'bounceInUp' },
                                { label: __('FadeIn','spice-blocks'), value: 'fadeIn' },
                                { label: __('FadeInDown','spice-blocks'), value: 'fadeInDown' },
                                { label: __('FadeInDownBig','spice-blocks'), value: 'fadeInDownBig' },
                                { label: __('FadeInLeft','spice-blocks'), value: 'fadeInLeft' },
                                { label: __('FadeInLeftBig','spice-blocks'), value: 'fadeInLeftBig' },
                                { label: __('FadeInRight','spice-blocks'), value: 'fadeInRight' },
                                { label: __('FadeInRightBig','spice-blocks'), value: 'fadeInRightBig' },
                                { label: __('FadeInUp','spice-blocks'), value: 'fadeInUp' },
                                { label: __('FadeInUpBig','spice-blocks'), value: 'fadeInUpBig' },
                                { label: __('Flip','spice-blocks'), value: 'flip' },
                                { label: __('FlipInX','spice-blocks'), value: 'flipInX' },
                                { label: __('FlipInY','spice-blocks'), value: 'flipInY' },
                                { label: __('LightSpeedIn','spice-blocks'), value: 'lightSpeedIn' },
                                { label: __('RollIn','spice-blocks'), value: 'rollIn' },
                                { label: __('RotateIn','spice-blocks'), value: 'rotateIn' },
                                { label: __('RotateInDownLeft','spice-blocks'), value: 'rotateInDownLeft' },
                                { label: __('RotateInDownRight','spice-blocks'), value: 'rotateInDownRight' },
                                { label: __('RotateInUpLeft','spice-blocks'), value: 'rotateInUpLeft' },
                                { label: __('RotateInUpRight','spice-blocks'), value: 'rotateInUpRight' },
                                { label: __('SlideInDown','spice-blocks'), value: 'slideInDown' },
                                { label: __('SlideInLeft','spice-blocks'), value: 'slideInLeft' },
                                { label: __('SlideInRight','spice-blocks'), value: 'slideInRight' },
                                { label: __('ZoomIn','spice-blocks'), value: 'zoomIn' },
                                { label: __('ZoomInDown','spice-blocks'), value: 'zoomInDown' },
                                { label: __('ZoomInLeft','spice-blocks'), value: 'zoomInLeft' },
                                { label: __('ZoomInRight','spice-blocks'), value: 'zoomInRight' },
                                { label: __('ZoomInUp','spice-blocks'), value: 'zoomInUp' },
			            	] }
		            		onChange={ (newtext) => setAttributes({ animation: newtext }) }					  
		        		/>  
				      	{ animation != '' && (
				        	<>
						        <SelectControl
						            label={__('Durations','spice-blocks')}
						            value={ durations }
						            options={ [
						            	{ label: __('Normal','spice-blocks'), value: ' ' },
						                { label: __('Slow','spice-blocks'), value: 'slow' },
						                { label: __('Fast','spice-blocks'), value: 'fast' },
						            ] }
						            onChange={ (newtext) => setAttributes({ durations: newtext }) }					  
						        />  
					        	<TextControl
						            label={__('Delay(ms)','spice-blocks')}			    
						            value={delay}
			        				onChange={(newtext) => setAttributes({ delay: newtext })}
							    />
							</>
							)
						}
					</PanelBody>
			</PanelBody>
			
			<PanelBody initialOpen={false} title={ __('Text Shadow','spice-blocks') }>	
				<RangeControl 
					label={ __('Horizontal Shadow(px)','spice-blocks') }			    
				    value={ hshadow}
				    onChange={(newtext) => setAttributes({ hshadow: newtext })}
					min={0}
					max={100}
				/>
				<RangeControl 
					label={ __('Vertical Shadow(px)','spice-blocks') }			    
				    value={ vshadow}
		        	onChange={(newtext) => setAttributes({ vshadow: newtext })}
					min={0}
					max={100}
				/>	
				<RangeControl 
					label={ __('Blur Shadow(px)','spice-blocks') }			    
				    value={ blurshadow}
		        	onChange={(newtext) => setAttributes({ blurshadow: newtext })}
					min={0}
					max={100}
				/>
				<PanelColorSettings  initialOpen={true}
					className='spice-block-section-bg-color'
					title={ __('Text Shadow','spice-blocks') }
					colorSettings={[
						{
						value: shadowColor,
						enableAlpha:true,
						onChange: setShadowColor,
						label: __('Text Shadow','spice-blocks')
						},
					]}
				/>
			</PanelBody>

			<PanelBody initialOpen={false}	title={__('Color & Background Settings','spice-blocks')}>
				<PanelColorSettings  className={'spice-blocks-color-style'}
					colorSettings={[
						{
							value: titleColor,
							enableAlpha:true,
							clearable: true,
							onChange: setTitleColor,
							label: __('Heading','spice-blocks')
						},
						{
							value: bgColor,
							enableAlpha:true,
							clearable: true,
							onChange: setBgColor,
							label: __('Background','spice-blocks')
						},
					]}
				/>
			</PanelBody>
				
			<PanelBody initialOpen={false} title={__('Typography Settings','spice-blocks')} className={"spiceheadingtypo"} >
				
				<SelectControl
		            label={__(' Font Family','spice-blocks')}
		            value={ fontfamily }
		            options={fontfamilylist}
		            onChange={ (newtext) => setAttributes({ fontfamily: newtext }) }
		        />			    
		        <FontSizePicker 
		        	__nextHasNoMarginBottom
		            value={ titlefontSize }
		            onChange={(userVal) => setAttributes({
								titlefontSize: userVal
							})}
		            allowReset={false}
		        />
		        <SelectControl
		            label={__('Font Weight','spice-blocks')}
		            value={ TitleFontWeight }
		            options={ [
		                { label: __('Thin','spice-blocks'), value: '100' },
		                { label: __('Extra Light','spice-blocks'), value: '200' },
		                { label: __('Light','spice-blocks'), value: '300' },
		                { label: __('Regular','spice-blocks'), value: '400' },
		                { label: __('Medium','spice-blocks'), value: '500' },
		                { label: __('Semi Bold','spice-blocks'), value: '600' },
		                { label: __('Bold','spice-blocks'), value: '700' },
		                { label: __('Extra Bold','spice-blocks'), value: '800' },
		                { label: __('Black','spice-blocks'), value: '900' },
		            ] }
		            onChange={ (newtext) => setAttributes({ TitleFontWeight: newtext }) }					  
		        />
		        <RangeControl 
					label={__('line Height(px)','spice-blocks')}			    
				    value={ TitleLineHeight}
		        	onChange={(newtext) => setAttributes({ TitleLineHeight: newtext })}
					min={0}
					step={0.1}
					max={100}
				/>
				<SelectControl
		            label={__('Transform','spice-blocks')}
		            value={ TitleTransform }
		            options={ [
		                { label: __('Default','spice-blocks'), value: '' },
		                { label: __('Uppercase','spice-blocks'), value: 'uppercase' },
		                { label: __('Lowercase','spice-blocks'), value: 'lowercase' },
		                { label: __('Capitalize','spice-blocks'), value: 'capitalize' },
		            ] }
		            onChange={ (newtext) => setAttributes({ TitleTransform: newtext }) }					  
	        	/>

		        <SelectControl
		            label={__('Decoration ','spice-blocks')}
		            value={ TitleDecoration }
		            options={ [
		                { label: __('Default','spice-blocks'), value: '' },
		                { label: __('Underline','spice-blocks'), value: 'underline' },
		                { label: __('Overline','spice-blocks'), value: 'overline' },
		                { label: __('Line Through','spice-blocks'), value: 'line-through' },
		            ] }
		            onChange={ (newtext) => setAttributes({ TitleDecoration: newtext }) }					  
		        />

		        <RangeControl 
					label={__('Letter Spacing','spice-blocks')}			    
				    value={ TitleLetterSpacing}
		        	onChange={(newtext) => setAttributes({ TitleLetterSpacing: newtext })}
					min={-10}
					step={0.1}
					max={10}
				/>

	        </PanelBody> 
	        <PanelBody initialOpen={false} title={__('Additional Settings','spice-blocks')}>
                <InputControl
                    label={__('Additional Class','spice-blocks')}
                    value={ addclass }
                    onChange={ (userVal)=> setAttributes({addclass:userVal}) }
                />
                <TextareaControl
                    label={__('Custom CSS','spice-blocks')}
                    value={ customcss }
                    onChange={ (userVal)=> setAttributes({customcss:userVal}) }
                />
            </PanelBody>      				

		</InspectorControls>

		<BlockControls>
			<AlignmentToolbar
				value={attributes.textAlignment}
				onChange={(newalign) => setAttributes({ textAlignment: newalign })}
			/>			
		</BlockControls>

		<RichText
			key="editable"
			tagName={ Contenttag }
			className={`${blockclass} ${alignmentClass} ${animationclass} ${displayclass} ${addclass}`}
			placeholder={__('Enter Heading Here...','spice-blocks')}
			value={title}
			onChange={setTitle}
			style={{color:titleColor,
					backgroundColor:bgColor,
					margin: `${margins.top} ${margins.right} ${margins.bottom} ${margins.left}`,
					padding: `${paddings.top} ${paddings.right} ${paddings.bottom} ${paddings.left}`,								
					fontSize: titlefontSize,
					fontWeight: TitleFontWeight,
					lineHeight: `${TitleLineHeight}px`,
					animationDelay: delay + 'ms',
					textShadow: `${hshadow}px ${vshadow}px ${blurshadow}px ${shadowColor}`,
					fontFamily:fontfamily,
					textTransform:TitleTransform,
					textDecoration:TitleDecoration,
					letterSpacing:TitleLetterSpacing,
				}}
		/>
	</Fragment>
	);
};
 

registerBlockType('spice-blocks/spice-heading',{

	title:__('Heading','spice-blocks'),
	icon: <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="#09A223" d="M456 89.3v333.3h33.3c9.2 0 16.7 7.5 16.7 16.7v33.3c0 9.2-7.5 16.7-16.7 16.7H322.7c-9.2 0-16.7-7.5-16.7-16.7v-33.3c0-9.2 7.5-16.7 16.7-16.7H356V289.3H156v133.3h33.3c9.2 0 16.7 7.5 16.7 16.7v33.3c0 9.2-7.5 16.7-16.7 16.7H22.7c-9.2 0-16.7-7.5-16.7-16.7v-33.3c0-9.2 7.5-16.7 16.7-16.7H56V89.3H22.7C13.5 89.3 6 81.9 6 72.7V39.3c0-9.2 7.5-16.7 16.7-16.7h166.7c9.2 0 16.7 7.5 16.7 16.7v33.3c0 9.2-7.5 16.7-16.7 16.7H156v133.3h200V89.3h-33.3c-9.2 0-16.7-7.5-16.7-16.7V39.3c0-9.2 7.5-16.7 16.7-16.7h166.7c9.2 0 16.7 7.5 16.7 16.7v33.3c0 9.2-7.5 16.7-16.7 16.7H456z"/></svg>,
	category:'spice-blocks',
	example: {
        'attributes' : {
            'mode' : 'preview',
        }
    },
	keywords:['Spice Heading','Heading','Title'],
	supports: {
		html: false,
		anchor: true,
		spacing: {
		    margin: true,
		    padding: true,
    	}
	},
	attributes:{
		title:{
			type:'string',
		},
		Contenttag:{
			type:'string',
			default:'h2'
		},
		textAlignment: {
			type: 'string',
			default:'left'
		},
		mediaId: {
			type: 'number',
			default: 0
		},
		mediaUrl: {
			type: 'string',
			default: ''
		},
		titleColor:{
			type:'string',
		},
		bgColor:{
	    	type:'string',
	    },
	    shadowColor:{
	    	type:'string',
	    	default:'#ADACAC'
	    },
		margins: {
	        default: {
	            top: '0px',
	            left: '0px',
	            right: '0px',
	            bottom: '0px'
	        }
    	},
		paddings:{
			type: 'object',
		    default: {
		        top: '0px',
		        left: '0px',
		        right: '0px',
		        bottom: '0px',
		      },
		},
    	hshadow: {
			type: 'number',
			default: 0
		},
		vshadow: {
			type: 'number',
			default: 0
		},
		blurshadow: {
			type: 'number',
			default: 0
		},		
	    hidedesktop:{
	    	type: 'boolean',
			default: true
	    },
	    hidetablet:{
	    	type: 'boolean',
			default: true
	    },
	    hidemobile:{
	    	type: 'boolean',
			default: true
	    },
	    animation:{
	    	type:'string',
	    	default:''
	    },
	    durations:{
	    	type:'string',
	    },
	    delay:{
	    	type:'string',
	    }, 
	    fontfamily:{
	    	type:'string',
	    	default:'Open Sans',
	    },
	    titlefontSize:{
			type:'string',
		},
		TitleFontWeight:{
			type:'string',
			default:'600',
		},
    	TitleLineHeight:{
	    	type:'number',
	    },
	    TitleTransform:{
	    	type:'string'
	    },
	    TitleDecoration:{
	    	type:'string'
	    },
	    TitleLetterSpacing:{
	    	type:'number'
	    },
	    addclass:{
	    	type:'string',
	    },
	    customcss:{
	    	type:'string',
	    }
	},

	edit: BlockEdit,

	save:(props)=>{
		const { attributes } = props;
		const{ fontfamily, title, Contenttag, titleColor, bgColor, shadowColor, margins, paddings, titlefontSize, TitleLineHeight, TitleFontWeight, TitleTransform, TitleDecoration, TitleLetterSpacing, hshadow, vshadow, blurshadow, hidedesktop, hidetablet, hidemobile, animation, durations, delay, addclass, customcss}=attributes;
		const blockclass='spice-blocks-heading';
		const alignmentClass = (attributes.textAlignment != null) ? 'has-text-align-' + attributes.textAlignment : '';
		const animationclass='wow animated '+attributes.durations+' '+attributes.animation;
		const displaydesktop=(hidedesktop == false) ? 'hide-desktop' : '';
		const displaytablet=(hidetablet == false) ? 'hide-tablet' : '';
		const displaymobile=(hidemobile == false) ? 'hide-mobile' : '';
		const displayclass=displaydesktop+' '+displaytablet+' '+displaymobile;
		
		return(
			<>	
				<script> 
					var fontfamily2=`{fontfamily}`;
					var url2 = 'https://fonts.googleapis.com/css2?family='+fontfamily2+':wght@100;200;300;400;500;600;700;800;900&display=swap';
					var link2 = document.createElement('link');
					link2.href = url2;
					link2.rel = "stylesheet";
					link2.type =  "text/css";	          
					document.head.appendChild(link2);
				</script>
				<style dangerouslySetInnerHTML={{
			  		__html: [
				     `${customcss}`					
				    ].join('\n')
				  }}>
				  </style>					
				<RichText.Content 
					tagName={ Contenttag }
					className={`${blockclass} ${alignmentClass} ${animationclass} ${displayclass} ${props.attributes.className} ${addclass}`}
					value={attributes.title}
					style={{color:titleColor,
						backgroundColor:bgColor,
						margin: `${margins.top} ${margins.right} ${margins.bottom} ${margins.left}`,
						padding: `${paddings.top} ${paddings.right} ${paddings.bottom} ${paddings.left}`,								
						fontSize: titlefontSize,
						fontWeight: TitleFontWeight,
						lineHeight: `${TitleLineHeight}px`,
						animationDelay: delay + 'ms',
						textShadow: `${hshadow}px ${vshadow}px ${blurshadow}px ${shadowColor}`,
						fontFamily:fontfamily,
						textTransform:TitleTransform,
						textDecoration:TitleDecoration,
						letterSpacing:TitleLetterSpacing,
					}}
				/>
			</>
		)
	}
})